import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center p-16 text-[var(--text-muted)]">
      {Icon && <Icon className="size-12 mb-4 opacity-40" />}
      <h3 className="text-base text-[var(--text-secondary)] mb-2">{title}</h3>
      {description && <p className="text-xs max-w-xs leading-relaxed">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
